import { useLocation } from "../hooks/useLocation.js";
import { ALL_LOCATIONS_ID } from "../constants.js";
import { IdLabel } from "../../../components/IdLabel/index.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Locations/shared/LocationName.tsx
var LocationName = ({ locationId, showId, truncate = false }) => {
	const allLocations = locationId === ALL_LOCATIONS_ID;
	const { data } = useLocation({ locationId }, {
		cacheStrategy: "cache-only",
		fire: !allLocations
	});
	if (allLocations) return /* @__PURE__ */ jsx("span", {
		className: classnames({ truncate }, "min-w-0"),
		children: "All Locations"
	});
	if (data?.location) return /* @__PURE__ */ jsxs("span", {
		className: classnames({ truncate }, "min-w-0"),
		children: [data.location.name, showId && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx(IdLabel, {
			className: "text-color-subtle font-medium",
			idLabel: data.location.idLabel
		})] })]
	});
	return null;
};
//#endregion
export { LocationName };

//# sourceMappingURL=LocationName.js.map